/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { SchemaFilter } from '../../../../types/SchemaFilter';
import { SchemaSort } from '../../../../types/SchemaSort';

export const SchemaSearchRequest: core.serialization.Schema<
    serializers.SchemaSearchRequest.Raw,
    Truvity.SchemaSearchRequest
> = core.serialization.object({
    filter: core.serialization.list(SchemaFilter).optional(),
    sort: core.serialization.list(SchemaSort).optional(),
});

export declare namespace SchemaSearchRequest {
    export interface Raw {
        filter?: SchemaFilter.Raw[] | null;
        sort?: SchemaSort.Raw[] | null;
    }
}
